/*

ACTION TYPES USED FOR OUR ACTION CREATORS MUST BE DEFINED HERE AND EXPORTED
TO KEEP IT SIMPLE FOR NOW WE HAVE IT IN ONE FILE BUT IF THE SIZE GROWS SUBSTANTIALLY
WE MIGHT HAVE TO REFACTOR THEM INTO SEPARATE ACTION TYPE FILES

*/


// ------ CART ACTION TYPES ------ //

export const SET_CART = 'SET_CART';
export const UPDATE_SHIPPING_ADDRESS = 'UPDATE_SHIPPING_ADDRESS';
export const SET_SHIPPING_ADDRESS = 'SET_SHIPPING_ADDRESS';
export const UPDATE_LINE_ITEM = 'UPDATE_LINE_ITEM';
export const DELETE_LINE_ITEM = 'DELETE_LINE_ITEM';
export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER';
export const UPDATE_DELIVERY_DATE = 'UPDATE_DELIVERY_DATE';
export const UPDATE_BILLING_ADDRESS = 'UPDATE_BILLING_ADDRESS';
export const UPDATE_PAYMENT = 'UPDATE_PAYMENT';
export const REMOVE_CARD = 'REMOVE_CARD';

// ------ NAVIGATION ACTION TYPES ------ //

export const SET_CHECKOUT_STEP = 'SET_CHECKOUT_STEP';
export const SET_CAN_CONTINUE = 'SET_CAN_CONTINUE';
export const SET_LOADING = 'SET_LOADING';
export const SET_SHOW_ERROR = 'SET_SHOW_ERROR';
export const INCREMENT_ATTEMPTS = 'INCREMENT_ATTEMPTS';

// ------ CUSTOMER INFO ACTION TYPES ------ //

export const SET_CUSTOMER_INFO = 'SET_CUSTOMER_INFO';

// ------ FRONT CONFIG ACTION TYPES ------ //

export const SET_FRONT_CONFIG = 'SET_FRONT_CONFIG';

// ------ SHIPPING METHOD ACTION TYPES ------ //

export const SET_SHIPPING_SELECTION = 'SET_SHIPPING_SELECTION';
export const SET_PICKUP_STORE = 'SET_PICKUP_STORE';

// ------ PAYMENT ACTION TYPES ------ //

export const SET_PAYMENT_STATUS = 'SET_PAYMENT_STATUS';



//--------EXPANDED TYPE ACTION TYPES -----//

export const SET_EXPANDED_TYPE = 'SET_EXPANDED_TYPE';

//--------CONFIRM SCHEDULE TYPE ACTION TYPES -----//

export const SET_CONFIRM_SCHEDULE = 'SET_CONFIRM_SCHEDULE';
export const SET_CONFIRMATION_SUCCESS = 'SET_CONFIRMATION_SUCCESS';

//--------URL PARAMS ACTION TYPES -----//

export const SET_URL_PARAMS = 'SET_URL_PARAMS';

//--------BOOKING ACTION TYPES -----//

export const SET_BOOKING = 'SET_BOOKING';

